import React, { Component } from 'react';
import { isEmpty, size } from "lodash";
import { Box, Typography, Dialog, DialogTitle, DialogContent, IconButton, Table, TableBody, TableCell, TableRow, AppBar, Toolbar, TableHead, TableFooter, TablePagination  } from '@mui/material';
import SwipeableTabs from '../../../container/MUI/SwipeableTabs';
import { Close } from '@mui/icons-material';
import Currency from '../../common/Currency';
import Pagination from '../../../container/MUI/Pagination';
import StackedStats from '../../Stats/StackedStats';
import SpendingDetails from '../../Spendings/SpendingDetails';
import ScheduleAdmin from '../Timesheet/ScheduleAdmin';

class ChantierSingle extends Component {
    state = { 
        page: 0,
        rowsPerPage: 10,
        spendings: [],
        total: 0,
    }
    componentDidMount = async () => {
        this.filterSpendings()
    }
    handleChangePage = (event, page) => {
        this.setState({ page });
    };

    handleChangeRowsPerPage = event => {
        this.setState({ page: 0, rowsPerPage: parseInt(event.target.value) });
    };

    displayLabels = (labels) => {
        const { LABELS } = this.props;
        return labels.split(', ').map(label => LABELS && LABELS[label] && LABELS[label].label_name)
    }
    displayProjects = (projects) => {
        const { PROJECTS } = this.props;
        console.log('====================================');
        console.log(projects, PROJECTS);
        console.log('====================================');
        return projects.split(', ').map(project => PROJECTS && PROJECTS[project] && PROJECTS[project].project_name)
    }

    filterSpendings = () => {
        const { SPENDINGS, chantier } = this.props;
        let total = 0
        let filteredList = []
        chantier.chantier_spendings.forEach( item => {
            total += item.chantier_amount
            // item.spending = SPENDINGS[item.chantier_spending]
            Object.assign(item, SPENDINGS[item.chantier_spending])
            item.spending_amount = item.chantier_amount
            item.spending_amountTTC = item.chantier_amount
            filteredList.push(item)
        })
        
        filteredList.forEach(item => total += item.chantier_amount)
        console.log('====================================');
        console.log({filteredList});
        console.log('====================================');

        this.setState({
            spendings: filteredList,
            total
        })
    }
    displaySpendings = () => {
        const { rowsPerPage, page, spendings } = this.state;
        const { CATEGORIES, SUPPLIERS, LABELS, PROJECTS } = this.props;
        
        return spendings.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map( item => {
            let category = CATEGORIES.CHILD[item.spending_category]
            // let user = isEmpty(USERS) ? {} : USERS[item.spending_user]
            let labels = LABELS && item.spending_labels && this.displayLabels(item.spending_labels)
            // let projects = PROJECTS && item.spending_project && this.displayProjects(item.spending_project)
            let supplier = isEmpty(SUPPLIERS) ? {} : SUPPLIERS[item.spending_supplier]

            return (
                <TableRow 
                    hover
                    key={item.spending_id}
                    onClick={() => this.setState({openDetails: true, selectedSpending: item }) }
                >
                    <TableCell >
                        {new Date(item.spending_date).toLocaleDateString('fr-FR')}
                    </TableCell>
                    <TableCell >{category && category.category_name}</TableCell>                     
                    <TableCell >{item.spending_desc}</TableCell>   
                    <TableCell >{supplier && supplier.supplier_name}</TableCell>   
                    {/* <TableCell >{projects && projects.join(", ")}</TableCell>    */}
                    <TableCell >{labels && labels.join(", ")}</TableCell>   
                    <TableCell ><Currency value={item.chantier_amount} /></TableCell>                     
                    {/* <TableCell ><Currency value={item.spending_amountTTC} /></TableCell>                      */}
                    {/* <TableCell >
                        {!item.spending_fully_paid &&
                            <Currency value={item.spending_rest_to_pay} />
                        }
                    </TableCell>                      */}
                    
                </TableRow>
            )
        })
    }
    render() {
        const { chantier, CATEGORIES, SUPPLIERS, PAYMENTS, BANKS, PROJECTS, LABELS } = this.props;
        const { spendings, rowsPerPage, page, total, selectedSpending, openDetails} = this.state;
        return (
            <Dialog
                // disableBackdropClick
                open={true}
                // onClose={this.props.handleClose}
                onClose={(_, reason) => {reason !== "backdropClick" && this.props.handleClose()} }
                aria-labelledby="form-dialog-title"
                maxWidth="lg"
                fullScreen
                scroll="paper"
            >
                {openDetails && selectedSpending && 
                    <SpendingDetails 
                        supplier={SUPPLIERS && SUPPLIERS[selectedSpending.spending_supplier]} 
                        LABELS={LABELS}
                        PROJECTS={PROJECTS}
                        BANKS={BANKS}
                        PAYMENTS={PAYMENTS}
                        category={CATEGORIES.CHILD && CATEGORIES.CHILD[selectedSpending.spending_category]} 
                        spending={selectedSpending} 
                        view="ADMIN"
                        handleClose={()=> this.setState({openDetails: false, selectedSpending: {}})}
                        fetchSpendingPayments={this.props.fetchSpendingPayments}
                    />
                }
                <AppBar style={{position: 'relative'}} color="secondary">
                    <Toolbar>
                        <IconButton color="inherit" onClick={this.props.handleClose} aria-label="Close">
                            <Close />
                        </IconButton>
                        <Typography variant="h6" color="inherit">
                            {chantier.chantier_name} - {chantier.paygoID}
                        </Typography>
                    </Toolbar>
                </AppBar>
                <DialogContent>
                    <Box>
                        <SwipeableTabs
                            labels={["Statistiques", "Dépenses", "Planning"]}
                        >
                            <Box p={3}>
                                Total: <Currency value={total} />
                                <StackedStats 
                                    CATEGORIES={this.props.CATEGORIES.CHILD}
                                    SPENDINGS={this.state.spendings}
                                />
                            </Box>
                            <Box p={3}>
                                <Table>
                                    <TableHead>
                                        <TableRow>
                                        <TableCell>Créé le</TableCell>
                                            <TableCell>Catégorie</TableCell>
                                            <TableCell>Description</TableCell>
                                            <TableCell>Fournisseur</TableCell>
                                            <TableCell>Labels</TableCell>
                                            {/* <TableCell>Projets</TableCell> */}
                                            <TableCell>Montant</TableCell>
                                            {/* <TableCell>Reste à Payer</TableCell> */}
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {!isEmpty(spendings) && !isEmpty(CATEGORIES.CHILD) && this.displaySpendings()}
                                    </TableBody>
                                    {size(spendings) > 10 &&
                                        <TableFooter>
                                            <TableRow>
                                                <TablePagination
                                                    rowsPerPageOptions={[10, 30]}
                                                    labelRowsPerPage="Lignes par Page"
                                                    colSpan={7}
                                                    count={size(spendings)}
                                                    rowsPerPage={rowsPerPage}
                                                    page={page}
                                                    SelectProps={{
                                                        native: true,
                                                    }}
                                                    onPageChange={this.handleChangePage}
                                                    onRowsPerPageChange={this.handleChangeRowsPerPage}
                                                    ActionsComponent={Pagination}
                                                />
                                            </TableRow>
                                        </TableFooter>
                                    }
                                </Table>
                            </Box>
                            <Box p={3}>
                                <ScheduleAdmin
                                    {...this.props}
                                    chantierID={chantier.boxAssoId}
                                    // view="admin"
                                />
                            </Box>
                        </SwipeableTabs>
                    </Box>
                </DialogContent>
            </Dialog>
        );
    }
}

export default ChantierSingle;